const container = document.querySelector('.all-brands')

const buttons = Array.from(container.querySelectorAll('button')) 
const grid = container.querySelector('.all-brands__grid')
const groups = Array.from(container.querySelectorAll('.all-brands__grid > li'))

buttons.forEach(button => {
    button.addEventListener("click", () => {
        buttons.forEach(buttonElement => {
            buttonElement.classList.remove('button--primary')
            buttonElement.classList.add('button--secondary')
        })
    
        button.classList.remove('button--secondary')
        button.classList.add('button--primary')

        const buttonFilter = button.dataset.value;
        const isFilterApplied = buttonFilter !== 'ALL'

        if (isFilterApplied) {
            grid.classList.remove('all-brands__grid')
        } else {
            grid.classList.add('all-brands__grid')
        }

        groups.forEach(group => {
            if (isFilterApplied) {
                const groupName = group.dataset.value
                const isSelected = buttonFilter === groupName
                
                if (isSelected) {
                    group.classList.add('all-brands__grid')
                    group.style.display = 'block'
                } else {
                    group.classList.remove('all-brands__grid')
                    group.style.display = 'none'
                }
            } else {
                group.classList.remove('all-brands__grid')
                group.style.display = 'block'
            }
        })
    })
})